export const WEEKLY_UPDATES_LABEL = "project.creation.weekly.updates.label";
export const WEEKLY_UPDATES_TOOLTIP = "project.creation.weekly.updates.tooltip";
